import React from 'react';
import { Box } from '@mui/material';

const TextEditor = ({ content, onChange }) => {
  return (
    <Box sx={{ height: '100%', p: 2 }}>
      <textarea
        value={content}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          height: '100%',
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          resize: 'none',
          fontFamily: 'monospace'
        }}
      />
    </Box>
  );
};

export default TextEditor; 